export default __webpack_public_path__ + "static/fc8cc1fc098932258267d511487e1822.svg";